module.exports = __webpack_public_path__ + "img/video-in-home-blue.73caedc8.svg";